<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Reporte de Servicios</title>
</head>
<body>
<div class="report-container">
  <h1>Reporte de Servicios</h1>

  <!-- Filtros en una sola línea -->
  <form [formGroup]="reportForm">
    <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN) || this.hasRole(this.ADMIN_IOFE)">
      <label for="partner">Partner:</label>
      <select id="partner"
              formControlName="partner">
        <option *ngFor="let partner of partners"
                [ngValue]="partner">{{partner.name }}
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER) || this.hasRole(this.ADMIN_IOFE)">
      <label for="empresa">Empresa:</label>
      <select id="empresa"
              formControlName="enterprise">
        <option *ngFor="let enterprise of enterprises"
                [ngValue]="enterprise">{{enterprise.name }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="flujo">Flujo:</label>
      <select id="flujo"
              formControlName="workflow">
        <option *ngFor="let workflow of workflows"
                [ngValue]="workflow">{{workflow.description }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="desde">Desde:</label>
      <input type="date" id="desde" value="2024-10-16"
             formControlName="dateStart">
    </div>

    <div class="form-group">
      <label for="hasta">Hasta:</label>
      <input type="date" X id="hasta" value="2024-10-16"
             formControlName="dateEnd">
    </div>

    <!-- Contenedor de los botones Buscar y Generar Reporte -->
    <div class="form-group">
      <button class="btn btn-outline-success font-weight-bold" type="submit"
              (click)="this.loadConsolidatedServices()">Buscar
      </button>
    </div>
    <div class="form-group">
      <button class="btn btn-outline-success font-weight-bold" type="button" (click)="this.downloadReport()">Generar
        Reporte
      </button>
    </div>
  </form>

  <!-- Tabla de resultados -->
  <div class="table-responsive mt-2 mb-2 ">
    <table>
      <thead>
      <tr>
        <th>#</th>
        <th>Servicio</th>
        <th>Cantidad Usada</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let totalServiceReport of totalServiceReports; let index=index" (click)="getDetailServiceReport(totalServiceReport)">
        <td title="#">{{index + 1}}</td>
        <td title="{{'TABLE.HEADER.YEAR' | translate }}">{{totalServiceReport.service}}</td>
        <td title="{{'TABLE.HEADER.MONTH' | translate }}">{{totalServiceReport.quantity}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
</body>
</html>
<app-loading *ngIf="loading"></app-loading>
